import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OCTOPUS_TAKO_EDITOR_CONFIG = createFcmDetails('octopus_tako_editor_config', {
	owner: 'SITE_PLATFORM',
	context: 'This FCM is used to configure the Tako rich text editor.',
	description:
		'This FCM is used to configure the rich text editor. Should be an object like this: { "toolbar": "bold italic underline fontsizeselect  forecolor backcolor | link |  bullist emoticons template" } ',
	template: {
		toolbar: 'bold italic underline fontsizeselect  forecolor backcolor | link |  bullist emoticons template',
	},
	import: false,
});
